import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

export const NewThreadDialog = ({ open, onClose, onCreated }) => {
  const [users, setUsers] = useState([]);
  const [sel, setSel] = useState([]);
  const [name, setName] = useState("");
  const [q, setQ] = useState("");
  useEffect(() => { if (open) { setSel([]); setName(""); setQ(""); api.get("/chat/users").then((r) => setUsers(r.data)); } }, [open]);
  const group = sel.length > 1;
  const toggle = (id) => setSel(sel.includes(id) ? sel.filter((x) => x !== id) : [...sel, id]);
  const create = async () => {
    try { const { data } = await api.post("/chat/threads", { type: group ? "group" : "direct", member_ids: sel, name }); onCreated(data); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const shown = users.filter((u) => u.name.toLowerCase().includes(q.toLowerCase()));
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="new-thread-dialog">
        <DialogHeader><DialogTitle>Nueva conversación</DialogTitle></DialogHeader>
        <p className="text-xs text-[#5b6656]">Elija una persona para una conversación directa, o varias para crear un grupo.</p>
        <Input data-testid="new-thread-search" placeholder="Buscar usuario…" value={q} onChange={(e) => setQ(e.target.value)} />
        <div className="max-h-64 overflow-y-auto rounded-lg border border-[#e4e8e1] divide-y divide-[#f0f2ee]">
          {shown.length === 0 && <div className="p-3 text-sm text-[#8a9584]">No hay otros usuarios activos</div>}
          {shown.map((u) => (
            <label key={u.id} className="flex items-center gap-3 px-3 py-2 text-sm cursor-pointer hover:bg-[#f6fbf2]">
              <Checkbox data-testid={`new-thread-user-${u.id}`} checked={sel.includes(u.id)} onCheckedChange={() => toggle(u.id)} />{u.name}
            </label>))}
        </div>
        {group && <Input data-testid="new-thread-name" placeholder="Nombre del grupo (ej. OT-2026-0012 Terreno)" value={name} onChange={(e) => setName(e.target.value)} />}
        <DialogFooter><Button data-testid="new-thread-create-btn" className="rounded-full" disabled={!sel.length || (group && name.trim().length < 2)} onClick={create}>
          {group ? "Crear grupo" : "Iniciar conversación"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
